import { GET_PERSONAL_INFO, LOAD_PERSONAL_INFO } from "../actions/types";

const initialState = {
  personalInfo: {},
  resourceInfo: {},
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_PERSONAL_INFO:
      return {
        ...state,
        personalInfo: action.payload.personalInfo,
        resourceInfo: action.payload.resourceInfo,
        loading: false,
      };
    case LOAD_PERSONAL_INFO:
      if (action.payload === true) {
        return {
          ...state,
          loading: action.payload,
          personalInfo: {},
        };
      } else {
        return {
          ...state,
          loading: action.payload,
        };
      }
    default:
      return state;
  }
}
